import { TStatementEvaluationStatus } from './scorecard-section.model';

export type TChallengeStatus = 'Pending Review' | 'Approved' | 'Denied';

export interface IChallenge {
  updatedJustification: string;
  status: TChallengeStatus;
  userFirstName: string;
  userLastName: string;
  challengeDate: string;
  userEmail: string;
  userId: number | null;
  reviewedDate: string;
  reviewerEmail: string;
  reviewerFirstName: string;
  reviewerLastName: string;
  reviewerUserId: number;
  comment: string;
}

export interface IStatementChallenge extends IChallenge {
  id: number;
  statementId: number;
  updatedEvaluationStatus: TStatementEvaluationStatus;
}

export interface IScorecardChallenge extends IChallenge {
  id: string;
}

export class StatementChallengeModel implements IStatementChallenge {
  id: number = 0;
  statementId: number = 0;
  status!: TChallengeStatus;
  updatedEvaluationStatus!: TStatementEvaluationStatus;
  updatedJustification: string = '';
  userFirstName: string = '';
  userLastName: string = '';
  challengeDate: string = '';
  userEmail: string = '';
  userId: number | null = null;
  reviewedDate: string = '';
  reviewerEmail: string = '';
  reviewerFirstName: string = '';
  reviewerLastName: string = '';
  reviewerUserId: number = 0;
  comment: string = '';

  constructor(data: IStatementChallenge) {
    if (data) {
      this.id = data?.id ?? this.id;
      this.statementId = data?.statementId ?? this.statementId;
      this.status = data?.status ?? this.status;
      this.updatedEvaluationStatus = data?.updatedEvaluationStatus ?? this.updatedEvaluationStatus;
      this.updatedJustification = data?.updatedJustification ?? this.updatedJustification;
      this.userFirstName = data?.userFirstName ?? this.userFirstName;
      this.userLastName = data?.userLastName ?? this.userLastName;
      this.challengeDate = data?.challengeDate ?? this.challengeDate;
      this.userEmail = data?.userEmail ?? this.userEmail;
      this.userId = data?.userId ?? this.userId;
      this.reviewedDate = data?.reviewedDate ?? this.reviewedDate;
      this.reviewerEmail = data?.reviewerEmail ?? this.reviewerEmail;
      this.reviewerFirstName = data?.reviewerFirstName ?? this.reviewerFirstName;
      this.reviewerLastName = data?.reviewerLastName ?? this.reviewerLastName;
      this.reviewerUserId = data?.reviewerUserId ?? this.reviewerUserId;
      this.comment = data?.comment ?? this.comment;
    }
  }
}

export class ScorecardChallengeModel implements IScorecardChallenge {
  id: string = '';
  scorecardId: number = 0;
  status!: TChallengeStatus;
  justification: string = '';
  userFirstName: string = '';
  userLastName: string = '';
  challengeDate: string = '';
  updatedJustification: string = '';
  userEmail: string = '';
  userId: number | null = null;
  reviewedDate: string = '';
  reviewerEmail: string = '';
  reviewerFirstName: string = '';
  reviewerLastName: string = '';
  reviewerUserId: number = 0;
  comment: string = '';

  constructor(data: IScorecardChallenge) {
    if (data) {
      this.id = data?.id ?? this.id;
      this.status = data?.status ?? this.status;
      this.justification = data?.updatedJustification ?? this.updatedJustification;
      this.userFirstName = data?.userFirstName ?? this.userFirstName;
      this.userLastName = data?.userLastName ?? this.userLastName;
      this.challengeDate = data?.challengeDate ?? this.challengeDate;
      this.userEmail = data?.userEmail ?? this.userEmail;
      this.userId = data?.userId ?? this.userId;
      this.reviewedDate = data?.reviewedDate ?? this.reviewedDate;
      this.reviewerEmail = data?.reviewerEmail ?? this.reviewerEmail;
      this.reviewerFirstName = data?.reviewerFirstName ?? this.reviewerFirstName;
      this.reviewerLastName = data?.reviewerLastName ?? this.reviewerLastName;
      this.reviewerUserId = data?.reviewerUserId ?? this.reviewerUserId;
      this.comment = data?.comment ?? this.comment;
    }
  }
}
